<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                      <el-row>
                        <el-col :span="12" class="item">
                          <el-form-item label="来访人姓名" required prop="visitorName">
                            <el-input v-model="editForm.visitorName" placeholder="请输入来访人姓名"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12" class="item">
                          <el-form-item label="来访人手机" required prop="visitorPhone">
                            <el-input v-model="editForm.visitorPhone" maxlength="11" placeholder="请输入来访人手机"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24" class="item">
                          <el-form-item label="描述" required prop="remarks">
                            <el-input v-model="editForm.remarks" type="textarea" placeholder="请输入描述"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        data() {
            return {
                loading: false,
              editForm:{
                timeStr:timeStr,
                sign:'',
                staffCode:getStaffCode(),
                receptionRecordCode:'',
                visitorName:'',
                visitorPhone:'',
                remarks:'',
              },

                rules:{
                  visitorName:[
                    { required: true, message: '请输入来访人姓名', trigger: 'blur' },
                  ],
                  visitorPhone:[
                    { required: true, message: '请输入来访人手机', trigger: 'blur' },
                    {
                      pattern: /^1[3456789]\d{9}$/,
                      message: '请输入正确的手机号', trigger: 'blur'
                    }
                  ],
                  remarks:[
                    { required: true, message: '请输入描述', trigger: 'blur' },
                  ],
                }

            }
        },

        methods: {

            init(row){
                //console.log(row);
                this.editForm.visitorName = row.visitorName;
                this.editForm.visitorPhone = row.visitorPhone;
                this.editForm.remarks = row.remarks;
                this.editForm.receptionRecordCode = row.receptionRecordCode;
            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ReceptionRecord/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
